import { GzExchangeAntimalwareSettingsFormWebComponent } from './component/GzExchangeAntimalwareSettingsFormWebComponent';

export { GzExchangeAntimalwareSettingsFormWebComponent };
